<ion-input
  [type]="props.type || 'text'"
  [attr.inputmode]="props.inputMode ?? null"
  [placeholder]="props.placeholder"
  [formControl]="formControl"
  [ionFormlyAttributes]="field"
>
</ion-input>
